import { Timestamp } from 'firebase/firestore';

// Kleine lokale startcache voor de gegevens die het eerste scherm nodig heeft
// (profiel, agenda met boekingen, beschikbaarheid, teamleden).
//
// Waarom naast Firestore's eigen cache? Firebase Auth bevestigt een bewaarde sessie
// pas na een netwerkronde (tokenvernieuwing en accountopvraging), en Firestore wacht
// daar volledig op: ook gegevens die al op het toestel staan komen pas na die ronde
// binnen. Deze cache wordt wel direct (synchroon) gelezen, zodat de agenda al
// zichtbaar is terwijl Firebase nog wakker wordt. Zodra Firestore antwoordt vervangen
// de echte gegevens deze stand en wordt de cache weer bijgewerkt: de cache is enkel
// een snelle eerste indruk, nooit de bron van waarheid.
//
// Gegevens van een account staan onder de uid van dat account en alles wordt gewist
// bij uitloggen (zie AuthContext), zodat een volgende gebruiker op hetzelfde toestel
// er niets van ziet. Bewaar hier NOOIT rol-, abonnements- of rechtenvelden die iets in
// de interface ontgrendelen (role, subscription, isTester, ...).

const VOORVOEGSEL = 'flexitime-cache.';

// JSON kent geen datums en Firestore-tijdstippen: die gaan als aparte vorm mee en
// worden bij het lezen weer echte Date- en Timestamp-objecten (de app leest ze later
// met .toDate() en .seconds). JSON.stringify roept toJSON al aan vóór de replacer,
// vandaar dat de ruwe waarde via `this` opgehaald wordt.
function vervangWaarde(sleutel, waarde) {
    const ruw = this[sleutel];
    if (ruw instanceof Date) {
        return Number.isNaN(ruw.getTime()) ? null : { __datum: ruw.getTime() };
    }
    if (ruw instanceof Timestamp) {
        return { __ts: [ruw.seconds, ruw.nanoseconds] };
    }
    return waarde;
}

function herstelWaarde(sleutel, waarde) {
    if (waarde && typeof waarde === 'object') {
        if (typeof waarde.__datum === 'number') return new Date(waarde.__datum);
        if (Array.isArray(waarde.__ts) && waarde.__ts.length === 2) {
            return new Timestamp(waarde.__ts[0], waarde.__ts[1]);
        }
    }
    return waarde;
}

/** Geeft de bewaarde waarde terug, of `null` als er niets (bruikbaars) bewaard is. */
export function leesStartCache(sleutel) {
    try {
        const ruw = localStorage.getItem(VOORVOEGSEL + sleutel);
        return ruw ? JSON.parse(ruw, herstelWaarde) : null;
    } catch {
        return null;
    }
}

export function schrijfStartCache(sleutel, waarde) {
    try {
        localStorage.setItem(VOORVOEGSEL + sleutel, JSON.stringify(waarde, vervangWaarde));
    } catch {
        // Opslag vol of geblokkeerd, dan is de volgende start gewoon wat trager.
    }
}

/** Wist de hele startcache (alleen de eigen sleutels), aangeroepen bij het uitloggen. */
export function wisStartCache() {
    try {
        const teWissen = [];
        for (let i = 0; i < localStorage.length; i++) {
            const sleutel = localStorage.key(i);
            if (sleutel && sleutel.startsWith(VOORVOEGSEL)) teWissen.push(sleutel);
        }
        teWissen.forEach((sleutel) => localStorage.removeItem(sleutel));
    } catch {
        // Geblokkeerde opslag, dan was er ook niets bewaard.
    }
}
